import bbox from "@turf/bbox";
import { Feature, geometry, Geometry } from "@turf/turf";
import * as turf from '@turf/turf';
import { WebMercatorViewport } from "react-map-gl";
import { Field } from "../types/types";
import { defaultViewport } from '../constants';
export const INTERNAL_FIELD_ID = '__id';

export const METERS_TO_ACRES = 0.00024711;

export const zoomToFeatures = (geojson: any, prevViewport:any, width: number, height: number, padding: number) => {
    let nextViewport = new WebMercatorViewport({
        ...prevViewport,
        width,
        height
    });

    if(geojson.features.length) {
        const [minLng, minLat, maxLng, maxLat] = bbox(geojson);
        console.log('zoomToFeatures', minLng, minLat, maxLng, maxLat);
        nextViewport = nextViewport.fitBounds([
            [minLng, minLat],
            [maxLng, maxLat]
        ], {
            padding
        });
    }

    return nextViewport;
}

export const zoomToFeature = (feature: any, viewport: any, width: number, height: number, padding: number) => {
    const [minLng, minLat, maxLng, maxLat] = bbox(feature.geometry);

    // help control the web mercator exception based on small small width
    const newPadding = width < 600 ? 85 : padding;

    const nextViewport = new WebMercatorViewport({
        ...viewport,
        width,
        height,
        pitch: 0,
        bearing: 0
    }).fitBounds([
        [minLng, minLat],
        [maxLng, maxLat]
    ], {
        padding: newPadding
    });

    return nextViewport;
}

export const createDataSource = (features: any[]): any => {
    let geojson: any = {
        type: "FeatureCollection",
        crs: { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
        features: features ? features.map((f: any) => {
            return f.feature;
        }) : []
    };

    return geojson;
}

export const createFeatureCollection = (features: any[]) => {
    
    let geojson: any = {
        type: "FeatureCollection",
        crs: { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
        features: features ? features.map((f: any) => {
            return f;
        }) : []
    };

    return geojson;
}

export const createFeatureCollectionFromFieldsGeometry = (features: any[]) => {
    console.log("Y050724 features", features);
    let geojson: any = {
        type: "FeatureCollection",
        crs: { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
        features: features ? features.map((f: any) => {
            f["geometry"] = f.geometry;
            return f;
        }) : []
    };

    return geojson;
}
export const createFeatureCollectionFromFields = (features: any[]) => {
    console.log("Y050724 features", features);
    let geojson: any = {
        type: "FeatureCollection",
        crs: { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
        features: features ? features.map((f: any) => {
            f["geometry"] = f.geom;
            return f;
        }) : []
    };

    return geojson;
}

export const createFeatureFromField = (field: Field): any => {
    const {geom, ...properties} = field;
    return {
        type: "Feature",
        "properties": {...properties},
        "geometry": geom
    };
}

export const createCentroidFeatureFromField = (field: Field): any => {
    const {centroid, ...properties} = field;
    const {name, id} = properties;
    return {
        type: "Feature",
        "properties": {name, id},
        "geometry": centroid.geometry
    };
}

export const __createCentroidFeatureFromGeom = (geom: any, props:any): any => {
    let centroid = turf.centroid(geom);
    const centerOfMass = turf.centerOfMass(geom);
    const pointOnFeature = turf.pointOnFeature(geom);

    console.log('A051724 props.label', props.label);
    //console.log('A051724 centroid pip', centroid);
    console.log('A051724 centerMass PIP', turf.booleanPointInPolygon(centerOfMass, geom));
    console.log('A051724 centroid PIP', turf.booleanPointInPolygon(centroid, geom));
    console.log('A051724 pointOnFeature PIP', turf.booleanPointInPolygon(pointOnFeature, geom));
    console.log('A051724 pointOnFeature WITHIN', turf.booleanWithin(pointOnFeature, geom));
    let __centroid = pointOnFeature;
    if (turf.booleanWithin(pointOnFeature, geom) === false && turf.booleanPointInPolygon(pointOnFeature, geom) === true){
        /*const directions = [0, 45, 90, 135, 180, 225, 270, 315, 360];
        //const directions = ['n', 's', 'e', 'w', 'ne', 'se', 'sw', 'nw'];
        for (const bearing of directions) {
            //const bearing = turf.bearingToAzimuth(direction);
            const movedPoint = turf.destination(pointOnFeature, (50 / 1000), bearing);
            if (turf.booleanWithin(movedPoint, geom)) {
                console.log(`AA051724 Point is within the geometry in the ${bearing} direction.`);
                centroid = movedPoint;
            } else {
                console.log(`Point is outside the geometry in the ${bearing} direction.`);
            }
        }*/
        createCentroidFeatureFromGeom(geom, props);
    }
    return {
        type: "Feature",
        "properties": geom.properties,// {name, id},
        "geometry": centroid.geometry
    };
}

export const createCentroidFeatureFromGeom = (_geom: any, props:any): any => {
    let furthestPoint:any = null;
    let geom:any = _geom;
    try {
        const line = turf.polygonToLine(_geom);
        const lineChunk = turf.lineChunk(line, 0.025, {units: 'kilometers'});
        console.log("A051825 lineChunk" , lineChunk)
        let coords = turf.coordAll(lineChunk);
        console.log("A051825 coords" , coords)
        let _coords = coords.map((c:any) => {
            return [c[0], c[1]];
        })
        console.log("A051825 _coords", _coords);
        const _line = turf.lineString(_coords);
        const __geom = turf.lineToPolygon(_line);
        console.log("A051825 line", line);
        console.log("A051825 __geom", __geom);
        geom = __geom; //turf.lineToPolygon(lineChunk);
        const vertices = turf.coordAll(geom);
        const bbox = turf.bbox(geom);
        const grid = turf.pointGrid(bbox, 0.025, { units: 'kilometers' }); // Adjust the grid size for accuracy and performance
        const pointsInside = turf.pointsWithinPolygon(grid, geom);

        let maxDistance = -Infinity;

        turf.featureEach(pointsInside, point => {
            const nearestVertexDistance = vertices.reduce((minDist, vertex) => {
                const dist = turf.distance(point, turf.point(vertex), { units: 'kilometers' });
                return Math.min(minDist, dist);
            }, Infinity);

            if (nearestVertexDistance > maxDistance) {
                maxDistance = nearestVertexDistance;
                furthestPoint = point;
            }
        });
    } catch (e) {
        console.log("A051825 e", e);
        furthestPoint = turf.pointOnFeature(_geom);
    }

    return {
        type: "Feature",
        properties: geom.properties,
        geometry: furthestPoint ? furthestPoint.geometry : null,
    };
};


export const createPolygonFeatureFromField = (field: Field): any => {
    const {geom, ...properties} = field;

    let geometry = {...field.geom};

    if(geometry.type === 'MultiPolygon') {
        geometry.type = 'Polygon';
        geometry.coordinates = geometry.coordinates[0]
    }
    console.log('Z050624 geometry', geometry);
    return {
        type: "Feature",
        "properties": {...properties},
        "geometry": geometry
    };
}

export const createPolygonFeatureFromFieldMulti = (field: Field): any => {
    const {geom, ...properties} = field;

    let geometry = {...field.geom};
    console.log("Z050724 field", field);
    let features = geometry.coordinates.map((coords: any, i:number) => {
        geometry.type = 'Polygon';
        geometry.coordinates = coords;
        console.log("Z050724 coords", coords);
        console.log("Y050724 geometry", geometry);
        console.log("Y050724 {...geometry}", {...geometry});
        return {
            type: "Feature",
            "properties": {
                ...properties,
                fragmentIndex: i,
            },
            "geometry": {...geometry},
        };
    });
    console.log("Y050724 features", features);
    return createFeatureCollectionFromFieldsGeometry([...features]);
}

export const createPolygonFeatureFromZones = (zones: any): any => {
    console.log('041924 zones', zones);
    const zoneFeatures = zones.map((zone: any) => {
        return {
            type: "Feature",
            "properties": {...zone},
            "geometry": zone.geom
        };
    })
    console.log('041924 zoneFeatures', zoneFeatures);
    return {"features":zoneFeatures};
}

export const coordsFromViewportParam = (param: string) => {
    return param.replace('@', '').split(',');
}

export const getViewport = (viewport: string, fields: any = null, width: any = null, height: any = null, caller:string = "") => {
    //console.log('013024 getViewport', viewport, fields, width, height);
    //console.log('013024 viewport', viewport, caller);
    let v = {...defaultViewport};

    if (fields?.length > 0){
        let _fields = createFeatureCollectionFromFields(fields);
        console.log('013024 _fields', _fields);
        const [minLng, minLat, maxLng, maxLat] = bbox(_fields);
        console.log('013024 zoomToFeatures', minLng, minLat, maxLng, maxLat);
        let viewportObj = zoomToFeatures(_fields, viewport, width, height, 100)
        viewport = `@${viewportObj.latitude},${viewportObj.longitude},${viewportObj.zoom}`;
    }

    if(viewport) {
        const coords = coordsFromViewportParam(viewport);

        if(coords.length === 3) {
           const [lat, lon, zoom] = coords;

            v.latitude =  parseFloat(lat);
            v.longitude = parseFloat(lon);
            v.zoom = parseFloat(zoom);
        }
    }
    //console.log('013024 v', v, caller);
    return v;
}

export const getFeaturesByType = (type: 'Polygon' | 'MultiPolygon', collection: any) => {
    console.log(type);
    if(collection.type === "FeatureCollection") {
        return collection.features.filter((f:any) => f.geometry.type === type);
    }
}

export const calculateAcres = (feature: Feature): number => {
    return turf.area(feature) * METERS_TO_ACRES
}

export const toMultiPolygonGeom = (feature: Feature) => {
    let geometry = {...feature.geometry} as any;

    if(feature.geometry.type !== 'MultiPolygon') {
        geometry.coordinates = [geometry.coordinates];      
        geometry.type = "MultiPolygon";
    }

    geometry.crs = {
        "type": "name",
        "properties": {
          "name": "urn:ogc:def:crs:EPSG::4326"
        }
    };

    return geometry;
}